<template>
  <ContentSection
    :spacing="isSustainabilityArticleWithSidebar ? 'sm-margin' : null"
  >
    <!-- TEXT -->
    <div
      v-if="!Array.isArray(data)"
      class="text-link ul-list-style-dot prose max-w-text sm:prose-big"
      v-html="data.text ? data.text : data"
    />

    <template v-else>
      <template v-for="(item, index) in data" :key="index">
        <!-- TEXT -->
        <div
          v-if="item.type === 'text'"
          class="text-link ul-list-style-dot prose max-w-text sm:prose-big"
          v-html="item.text || item"
        />

        <!-- BUTTON -->
        <AppButton
          v-if="item.type === 'app_button'"
          class="my-10 sm:my-12"
          :to="item.link"
          :target="item.target?.value"
        >
          {{ item.link_text }}
        </AppButton>
      </template>
    </template>
  </ContentSection>
</template>

<script setup>
defineProps({
  data: { type: [String, Object, Array], default: null },
})

const isSustainabilityArticleWithSidebar = inject(
  'isSustainabilityArticleWithSidebar',
  null
)
</script>
